<ng-container *ngIf="!hasCard">
  <div class="max-installment">
    <img
      src="/assets/icons/blue-info-icon.svg"
      alt="Ícono de información azul"
      class="max-installment__icon"
    />
    <h2 class="max-installment__title">Por favor, selecciona otro plan</h2>
    <p class="max-installment__description">
      En esta ocasión no podemos ofrecerte el plan de pago a {{ previousInstallmentsSelected }}
      cuotas.
    </p>
    <span class="max-installment__phrase"> Por favor, selecciona otro plan. </span>
    <div class="max-installment__button">
      <button class="btn-primary-bg" (click)="onCloseModal()">Seleccionar otro plan</button>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!!hasCard">
  <div class="max-installment">
    <img
      src="/assets/icons/blue-info-icon.svg"
      alt="Ícono de información azul"
      class="max-installment__icon"
    />
    <h2 class="max-installment__title">Por favor, selecciona otro plan</h2>
    <p class="max-installment__description">
      Actualmente, tu cuota máxima mensual disponible es de
      <span>{{ availableOffers?.score | powerpayCurrency }}</span
      >, por lo que en esta ocasión no podemos ofrecerte el plan elegido.
    </p>
    <span class="max-installment__phrase"> Por favor, selecciona otro plan. </span>
    <div class="max-installment__button">
      <button class="btn-primary-bg" (click)="onCloseModal()">Seleccionar otro plan</button>
    </div>
  </div>
</ng-container>
